export default __webpack_public_path__ + "f818d6aa7171e7e72a77dc2c19b3baf8.png";